import { call } from 'redux-saga/effects';

import api from 'api';

import { sendFeedback } from 'store/subscriptions/actions';

import { handleAuthError } from './utils';

export function* sendSubscriptionFeedback({ payload }: ReturnType<typeof sendFeedback>) {
    try {
        yield call(api.subscriptions.sendFeedback, payload);
    } catch (error) {
        const authErrorWasHandled = yield* handleAuthError(error);

        if (authErrorWasHandled) return;

        console.error(error);
    }
}
